import { createSelector } from 'reselect';
import type { RootState } from 'reducers/index';
import type {
  WebsitePreviewReducerState,
  WebsitePreviewWeddingValues,
} from 'reducers/website/websitePreview';

export const getWebsitePreview = (state: RootState): WebsitePreviewReducerState =>
  state.website.websitePreview;

export const getHeaderImageUrl = createSelector(getWebsitePreview, state => state.header_image_url);

export const getWebsitePreviewWeddingValues = (state: RootState): WebsitePreviewWeddingValues =>
  state.website.websitePreview.weddingValues;
